"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRefreshCw05 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M21.473 6.193a1 1 0 1 0-1.932-.518l-.109.406C16.553 2.457 11.38 1.389 7.25 3.773A9.488 9.488 0 0 0 2.552 11a1 1 0 0 0 1.989.212A7.502 7.502 0 0 1 17.645 7.06l-.343-.092a1 1 0 1 0-.518 1.932l2.732.732a1 1 0 0 0 1.225-.707l.732-2.732ZM21.448 12.999a1 1 0 1 0-1.989-.212A7.503 7.503 0 0 1 6.354 16.94l.345.092a1 1 0 0 0 .517-1.932l-2.732-.732a1 1 0 0 0-1.224.707l-.733 2.732a1 1 0 0 0 1.932.518l.109-.406c2.879 3.624 8.053 4.692 12.182 2.308A9.489 9.489 0 0 0 21.448 13Z", fill: "currentColor" }) }))); };
exports.default = SvgRefreshCw05;
